import { useState } from "react";
import { truncateHTML } from "../../../helpers/truncateHTML";
import TranslationIndicator from "../../shared/TranslationIndicator";

export default function AppointmentDescription({
  description,
  isRendered,
  translated,
}: {
  description: string;
  isRendered: boolean;
  translated?: boolean;
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const textContent = description.replace(/<[^>]*>/g, "");
  const truncateLength = 500;
  const shouldTruncate = textContent.length > truncateLength;

  const displayContent =
    shouldTruncate && !isExpanded
      ? truncateHTML(description, { length: truncateLength })
      : description;

  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  // break-words: a long link has no break of its own and would otherwise run
  // out of a narrow container, e.g. the appointment card of a widget
  return (
    <>
      {isRendered ? (
        <div className="detail-description prose prose-sm break-words">
          <div dangerouslySetInnerHTML={{ __html: displayContent }} />
          {shouldTruncate && !isExpanded && (
            <>
              <span>…</span>
              <button
                type="button"
                onClick={handleToggle}
                className="text-primary hover:underline"
              >
                {I18n.t("activitystreams.more")}
              </button>
            </>
          )}
        </div>
      ) : (
        <p className="whitespace-pre overflow-auto">{displayContent}</p>
      )}
      {translated && <TranslationIndicator />}
    </>
  );
}
